import { createContext } from 'react';

export const OrganisationContext = createContext([]);
